import { styled } from '@mui/material';
import { fluidSize } from '@rumblefish/ui/src/theme/rumblefish23Theme/utils';
import { StyledTypography } from '../styles';
export const JobPostBenefitsGridContainer = styled('div')<{
  rows?: number;
}>(({ rows = 3, theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridTemplateRows: `repeat(${rows}, 1fr)`,
  rowGap: theme.spacing(4),
  columnGap: theme.spacing(7),
  width: '100%',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'auto',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(1, 1fr)',
  },
}));

export const JobPostBenefitsGridItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: theme.spacing(3),
}));

export const BenefitIcon = styled('img')(({ theme }) => ({
  width: fluidSize({ minSize: 40, maxSize: 55 }),
  minWidth: fluidSize({ minSize: 40, maxSize: 50 }),
  height: 'auto',
  objectFit: 'contain',
  [theme.breakpoints.down('sm')]: {
    alignSelf: 'center',
  },
}));

export const BanefitName = styled(StyledTypography)({
  alignSelf: 'flex-start',
});
